import TypesSection from './TypesSection'

export default TypesSection
